<div class="grid login">
  <div class="col-1 lg:col-4 xl:col-4"></div>
  <div class="col-10 lg:col-4 xl:col-4">
    <h1 class="center">ようこそ</h1>
    <p-panel
      header="ログイン"
      class="center">
      <form
        [formGroup]="form"
        (ngSubmit)="doLogin()"
        #formDir="ngForm">
        <div class="formgrid grid">
          @if (loginFail) {
            <div class="field col-12">
              <p-message severity="error">メールアドレスまたはパスワードが間違っています</p-message>
            </div>
          }
          <div class="field col-12">
            <div class="custom-iconfield">
              <i class="pi pi-user"></i>
              <input
                type="text"
                class="ng-dirty ng-invalid"
                formControlName="email"
                pInputText
                placeholder="メールアドレス" />
            </div>
            @if (isEmailRequired()) {
              <p-message severity="error">メールアドレスは必須です</p-message>
            }
            @if (isEmailInvalid()) {
              <p-message severity="error">メールアドレスの形式が間違っています</p-message>
            }
          </div>

          <div class="field col-12 password-field">
            <div class="custom-iconfield">
              <i class="pi pi-key"></i>
              <input
                type="password"
                formControlName="password"
                pPassword
                placeholder="ログインパスワード" />
            </div>
            @if (isPasswordRequired()) {
              <p-message severity="error">パスワードは必須です</p-message>
            }
            @if (isPasswordLength()) {
              <p-message severity="error">パスワードは8文字以上です</p-message>
            }
          </div>

          <div class="field col-12 btn-full">
            <p-button
              label="ログイン"
              type="submit"
              severity="primary"
              [disabled]="form.invalid"></p-button>
          </div>

          <div class="field col-12 checkbox-section">
            <div class="items-center">
              <p-checkbox
                [formControlName]="'rememberMe'"
                inputId="rememberMe"
                binary="true"></p-checkbox>
              <label
                for="rememberMe"
                class="ml-2">
                ログインを記憶する
              </label>
            </div>
          </div>
        </div>
      </form>
    </p-panel>
  </div>
  <div class="col-1 lg:col-4 xl:col-4"></div>
</div>
